<template>
    <footer>
        <div>
          <!--<div id="logo-mini"></div>-->
	        <div>
	          <span>S.A.R.L. LOCK QUEST®</span> - ESCAPE GAME - ESCAPE GAME MOBILE - NESTOR BOMB SIMULATOR - JEUX DE PISTE EN PLEIN AIR
		        <br />6, chemin de Lamballard 14760 Bretteville-sur-Odon
            <br />SIRET - 853 196 822 00011
            <br />Site web réalisé par <a href="mailto:newfatioueg@hotmail.com">Vincent GOUEY</a>
          </div>
	      </div>
        <div>
            <a v-on:click="cgv_buttonClick">C.G.V.</a> 
            - <a href="/#concept">Concept</a> 
            - <a href="/nos-scenarios-escape-caen">Nos énigmes</a> 
            - <a href="/#nestor-bomb-simulator">NESTOR - Bomb Simulator</a> 
            - <a href="/#infos-pratiques">Infos pratiques</a> 
            - <a href="/entreprises">Entreprises</a> 
            - <a href="/nos-scenarios-escape-caen#bons-cadeaux">Bons cadeaux</a> 
            - <a href="/contact#faq">F.A.Q.</a> 
            - <a href="/contact">Contact</a> 
            - <a href="/#tarifs">Tarifs</a> 
            - <a href="/nos-scenarios-escape-caen">Réserver</a>
          </div>
        <div v-html="seo_contentH1"></div>
        <div v-html="seo_contentH2"></div>

        <CGV ref="cgvPopin" />
        <Covid19 ref="covid19Popin" />
        <Pass_Sanitaire ref="passSanitairePopin" />
    </footer>
</template>

<script>
import CGV from './CGV.vue';
import Covid19 from './Covid19.vue';
import Pass_Sanitaire from './Pass_Sanitaire.vue';

export default {
  name: "Footer",
  components: {
      CGV,
      Covid19,
      Pass_Sanitaire
  },
  props: {
    seo_contentH1: { type: String, default: "Lock Quest - Escape Game Caen (Bretteville-sur-Odon) : un parfum d'aventure et de légende" },
    seo_contentH2: { type: String, default: "Escape Game Caen (Bretteville sur Odon), jeu d’évasion grandeur nature et de loisirs à Caen.<br/>Un parfum d'aventure et de légende : chacun de nos scénarios vous fera voyager dans un pays du monde différent.<br/>Quelle sera votre destination ?" }
  },
  methods: {
    cgv_buttonClick: function(event) {
        this.$refs.cgvPopin.popin_cgvDisplayed();
    }
  },
  mounted() {
      /*this.$store.dispatch('passSanitaire/getData')
        .then((response) => {
          if (response && response.already_displayed) {
            return;
          }

          this.$refs['passSanitairePopin'].popin_passSanitaireDisplayed();
          this.$store.dispatch('passSanitaire/setData').then(() => { });
        });*/
  }
}
</script>
